import { Configuration } from './configuration.js';
import { BonusPenalty } from './bonus-penalty.js';
export abstract class BonusPenaltyT<T> extends BonusPenalty {
    abstract toState(config: Configuration): T;
}
